import { BaseMultibrandDictionaryItem } from '@/models/dictionary/common.model';

export type TagListItem = BaseMultibrandDictionaryItem & {
  tagId: string;
  color: string;
  sortingWeight: number | null;
}

export enum TagListParamsRequest {
  PLAYER = 'player',
  GAME = 'game',
}

export type TagListFilter = {
  name?: string;
  tagId?: string[];
  wlIdList?: string[] | string;
}

export type TagListRequestPayload = {
  object: TagListParamsRequest;
  filterList?: TagListFilter;
}

export type TagListPayload = {
  object: TagListParamsRequest;
  filterList?: TagListFilter;
  isForceUpdate?: boolean;
}
